import {
    AIRPORT_UPSERT_SUCCESS,
    AIRPORT_GETALL_SUCCESS,
    AIRPORT_DELETE_SUCCESS
  } from "../actions/types";
  
  const initialState = { airports: null }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case AIRPORT_UPSERT_SUCCESS:
        if (state.airports.filter(e => e.id == payload.id).length > 0) {
          return { ...state, airports: state.airports.map(airport => { return airport.id === payload.id ? payload : airport }) };
        } else {
          return { ...state, airports: [...state.airports, payload] }
        }
      case AIRPORT_DELETE_SUCCESS:
        return { ...state, airports: state.airports.filter(airport => airport.id !== payload) }
  
      case AIRPORT_GETALL_SUCCESS:
        return { ...state, airports: payload.airports };
      default:
        return { ...state };
    }
  }